module.exports = __webpack_public_path__ + "img/education.3a449ed9.svg";